import React, {useState} from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import Header from './components/Header';

function App() {
  const [showInstructions, setShowInstructions] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [startFromScratchHandler, setStartFromScratchHandler] = useState<(() => void) | null>(null);
  const [showStartFromScratch, setShowStartFromScratch] = useState(false);
  const [hideDownloadTemplate, setHideDownloadTemplate] = useState(false);
  const [goHomeHandler, setGoHomeHandler] = useState<(() => void) | null>(null);

  const handleStartFromScratchReady = (handler: () => void, show: boolean) => {
    setStartFromScratchHandler(() => handler);
    setShowStartFromScratch(show);
  };

  const handleHideDownloadTemplate = (hide: boolean) => {
    setHideDownloadTemplate(hide);
  };

  const handleGoHomeReady = (handler: () => void) => {
    setGoHomeHandler(() => handler);
  };

  const handleProgressDialogChange = (show: boolean) => {
    setShowProgress(show);
  };

  const handleResultDialogChange = (show: boolean) => {
    setShowResults(show);
  };

  const shouldHideHeader = showInstructions || showProgress || showResults;

  return (
    <div className="App">
      {!shouldHideHeader && (
        <Header 
          onShowInstructions={() => setShowInstructions(true)}
          onStartFromScratch={startFromScratchHandler || undefined}
          showStartFromScratch={showStartFromScratch}
          hideDownloadTemplate={hideDownloadTemplate}
          onGoHome={goHomeHandler || undefined}
        />
      )}
      <Dashboard 
        externalShowInstructions={showInstructions}
        onInstructionsClosed={() => setShowInstructions(false)}
        onStartFromScratchReady={handleStartFromScratchReady}
        onHideDownloadTemplate={handleHideDownloadTemplate}
        onGoHomeReady={handleGoHomeReady}
        onProgressDialogChange={handleProgressDialogChange}
        onResultDialogChange={handleResultDialogChange}
      />
    </div>
  );
}

export default App;
